import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Landing = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Immediately redirect to login
    navigate('/login', { replace: true });
  }, [navigate]);

  return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
    </div>
  );
};

export default Landing;
